import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {ReviewStatusVO} from "@/service/instance.s";
import {ExpensePO} from "@/model/finance";
import {WriteExpenseForm} from "@/pages/Expense/WriteExpense";

export enum ExpenseEnum {
    GetExpensePage = "/expense/getExpensePage",
    GetExpense = "/expense/getExpense",
    CreateExpense = "/expense/createExpense",
    UpdateExpense = "/expense/updateExpense",
}

export interface ExpensePageBO {
    keyword?: string;
    flag?: string
}

export interface ExpensePageVO extends ReviewStatusVO, ExpensePO {
}

export interface ExpenseSpanningVO extends ExpensePO, ReviewStatusVO {
    name: string;
    money: number;
    summary: string;
    _id: string
}

export interface ExpenseVO extends ExpensePO {

}

export const useQueryExpensePage = () => useMutation({
    mutationFn: (data: ExpensePageBO) => http.post<BaseVO<PaginationVO<ExpensePageVO>>>({
        url: ExpenseEnum.GetExpensePage,
        data: data,
    }),
})

export const useCreateExpense = () => useMutation({
    mutationFn: (data: WriteExpenseForm) => http.put({url: ExpenseEnum.CreateExpense, data}),
})

export const useUpdateExpense = () => useMutation({
    mutationFn: (data: WriteExpenseForm) => http.post({url: ExpenseEnum.UpdateExpense, data}),
})

export const useQueryExpense = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<ExpenseVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<ExpenseVO>>({
        url: ExpenseEnum.GetExpense,
        params: params
    }),
    enabled
})


